<template>
  <v-container fluid class="ma-0 pa-0 mt-2">

    <v-row dense >
      <v-col class="text-center blue darken-4 ">
        <div class="topHeader">
          <label class="white--text font-weight-bold">My Specialty Event Log</label>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pa-0 ma-0">
        <v-list three-line>
          <v-list-item-group
            active-class="blue--text"
          >
            <template v-for="(item, index) in values">
              <v-list-item :key="index">
                <!-- eslint-disable-next-line -->
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-1 font-weight-bold blue--text text--darken-4" v-text="item.contact"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.city + ', ' +item.state"></v-list-item-subtitle>
                    <v-list-item-subtitle><div :class="(item.type=='SFRO' ? 'red darken-4':'green darken-4') + ' white--text text-center shorten'">{{item.type}}</div></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text >
                      <v-btn v-if="item.homephoneshort != 'N/A'" class="mr-3" fab dark x-small  color="blue darken-4" :href="`tel:+1${item.homephoneshort}`">
                        <v-icon small dark>mdi-phone</v-icon>
                      </v-btn>
                      <v-btn v-if="item.cellphoneshort != 'N/A'" fab dark x-small color="green darken-4" :href="`tel:+1${item.cellphoneshort}`">
                        <v-icon small dark>mdi-cellphone</v-icon>
                      </v-btn>
                    </v-list-item-action-text>

                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-divider
              :key="item.capid"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </v-container>
</template>

<script>


export default {
  name: 'FROList',
  components: {

  },
  props: ['groupId'],
  data () {
    return {
      isLoading: false,
      values: []
    }
  },
  mounted() {
    this.getData();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);

    this.getData(this.typeId);

  },
  methods: {
    getData() {

    this.isLoading = true;

    var obj = {
      wing: this.selWing,
      toplevelgroupname: decodeURI(this.groupId)
    }

    this.$https.post(this.$vars.BaseUrl + this.$vars.GetFROListRoute, obj, this.$vars.config)
      .then(response => {
        //console.log(response);
        this.httpResponse = response;
        this.values = response.data;
        this.setFROList(response.data);
        this.isLoading = false;
      })
      .catch(e => {
        console.log(e);
        this.isLoading = false;
      });
    },
    toProperCase(str) {
      str = str.toLowerCase().split(' ');
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(' ');
    }
  }
}
</script>

<style scoped>
  .topHeader {
    height:45px
  }

.shorten {
  width: 60px;
  max-width: 60px
}

</style>
